import { useState, useEffect } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  VStack,
  Text,
  Spinner
} from '@chakra-ui/react'
import { FaWifi } from 'react-icons/fa'

interface InternetConnectionModalProps {
  speechNetworkError?: boolean
}

export function InternetConnectionModal({ speechNetworkError = false }: InternetConnectionModalProps) {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // Show modal if either offline OR speech recognition has network error
  const shouldShowModal = !isOnline || speechNetworkError

  return (
    <Modal isOpen={shouldShowModal} onClose={() => {}} isCentered closeOnOverlayClick={false}>
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent bg="#1a1a1a" border="1px solid" borderColor="red.500" maxW="300px">
        <ModalBody py={8}>
          <VStack spacing={4}>
            <FaWifi size={48} color="#E53E3E" />
            <Text color="white" fontSize="xl" fontWeight="bold" textAlign="center">
              Check Internet Connection
            </Text>
            <Spinner color="red.500" size="sm" />
            <Text color="gray.400" fontSize="sm" textAlign="center">
              {speechNetworkError ? 'Voice recognition reconnecting...' : 'Waiting for connection...'}
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
